import classNames from 'classnames'
import type { ReactElement } from 'react'
import { getAge } from 'app/date.utils'
import { CardSlot } from 'app/components/pipelines/CardSlot'
import { ContactNameIcon } from 'app/components/contacts/ContactNameIcon'
import type { ContactJson } from 'app/types/entities'
import type { ContactCardSection } from 'lib/cardRecipe'
import type { CardDensity } from 'lib/listCardConfig'

/** The contact's avatar, name (with age) and subtitle. Always the first region of a custom list's card. */
export function IdentitySection({
  section,
  contact,
  density,
}: {
  section: Extract<ContactCardSection, { kind: `identity` }>
  contact: ContactJson
  density: CardDensity
}): ReactElement {
  const compact = density === `compact`
  const nameText = `${contact.name ?? ``}${section.showAge && contact.birthDate ? `, ${getAge(contact.birthDate)}` : ``}`
  return (
    <div className={classNames(`flex gap-x-3 px-3`, compact ? `pb-2` : `pb-3`)}>
      {section.showAvatar && <ContactNameIcon contact={contact} widthClassName="w-8" heightClassName="h-8" />}
      <div className="flex min-w-0 flex-col justify-center">
        <span title={nameText || undefined} className="truncate text-ui-sm text-strong">
          {nameText}
        </span>
        {!compact && section.subtitle && (
          <CardSlot slot="subtitle" fieldId={section.subtitle} contact={contact} density={density} />
        )}
      </div>
    </div>
  )
}
